export default class Config {
    level: number;
    lives: number;
    width: number;
    height: number;
    memoryCount: number;

    constructor() {
        this.level = 1;
        this.lives = 1;
        this.width = 3;
        this.height = 3;
        this.memoryCount = this.level + 2;
    }
}